import { render, staticRenderFns } from "./FarmChangesTable.vue?vue&type=template&id=2d3b5508&scoped=true"
import script from "./FarmChangesTable.vue?vue&type=script&lang=js"
export * from "./FarmChangesTable.vue?vue&type=script&lang=js"
import style0 from "./FarmChangesTable.vue?vue&type=style&index=0&id=2d3b5508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3b5508",
  null
  
)

export default component.exports